module.exports = __webpack_public_path__ + "img/icon-success.2857b64c.png";